import { MediaSizes } from "./types"

export const BREAKPOINTS: { [key in MediaSizes]: number } = {
  huge: 1440,
  large: 1170,
  medium: 768,
  small: 450,
}
